import ajax from "@/lib/ajax";

/**
 * 读取文献分页数据
 * @param payload
 */
export async function QueryLiteraturePageList(payload: any) {
	let res = await ajax.post(
		`/api/services/app/PDMedicalLiterature/QueryLiteraturePageList`,
		payload
	);
	return res.data.result;
}
// 删除文献数据
export async function DeleteLiterature(payload: any){
	let res = await ajax.delete('/api/services/app/PDMedicalLiterature/DeleteLiterature', {params:payload})
	return res.data.result
}

// 保存影像学数据
export async function SaveLiteratureData(payload: any){
	let res = await ajax.post('/api/services/app/PDMedicalLiterature/SaveLiteratureData', payload)
	return res.data.result
}




// WEBPACK FOOTER //
// ./src/api/pdOutPatient/pdMedicalLiterature/index.ts